<template lang="pug">
  bloco#sitemap.-padding-desktop
    //- HEADER
    header(slot="header")
      titulo.-withbar.-upper Mapa do Site
      p Aqui está a estrutura de informações do site
    //- CONTENT
    .conteudo(slot="content")
      ul.listagem.lista
        li.item: router-link(:to="{ name: 'Index' }") Início
        li.item Institucional
          ul.listagem
            li.item: router-link(:to="{ name: 'Institucional', params: { slug: 'apresentacao' } }") Apresentação
            li.item: router-link(:to="{ name: 'Institucional', params: { slug: 'acoes' } }") Ações
            li.item
              a(href="https://calendar.google.com/calendar/embed?src=proadufrn%40gmail.com&ctz=America%2FFortaleza" target="_blank") Agenda Administrativa
            li.item: router-link(:to="{ name: 'Institucional', params: { slug: 'equipe' } }") Equipe
            li.item: router-link(:to="{ name: 'Institucional', params: { slug: 'organograma' } }") Organograma
            li.item
              router-link(:to="{ name: 'Unidades' }") Unidades
              //- ul.listagem
                li.item: router-link(:to="{ name: 'Institucional' }") ASTEC
                li.item: router-link(:to="{ name: 'CGTIndex' }") CGT
                li.item: router-link(:to="{ name: 'DCFIndex' }") DCF
                li.item: router-link(:to="{ name: 'DGCIndex' }") DGC
                li.item: router-link(:to="{ name: 'DGIIndex' }") DGI
                li.item: router-link(:to="{ name: 'DCOMIndex' }") DCOM
                li.item: router-link(:to="{ name: 'DSPIndex' }") DSP
        li.item: router-link(:to="{ name: 'Noticias' }") Notícias
        li.item: router-link(:to="{ name: 'Categorias' }") Documentos
        li.item: router-link(:to="{ name: 'Galeria' }") Galeria
        li.item: router-link(:to="{ name: 'Contato' }") Fale conosco
</template>

<style lang="scss">
  #sitemap {
    .conteudo {
      .listagem {
        margin: 5px 0 5px 15px;
        > .item {
          margin: 5px 0;
          &:before {
            content: '\f0da';
            font-family: FontAwesome;
            color: $color-blue-dark;
            margin-right: 7px;
          }
        }
      }
      > .lista {
        margin: 30px 0;
      }
    }
  }
</style>

<script>
import Bloco from 'COMPONENTS/Bloco'
import Titulo from 'COMPONENTS/ElementTitle'

export default {
  components: {
    Bloco,
    Titulo
  }
}
</script>



// WEBPACK FOOTER //
// Sitemap.vue?35c1b2a0